var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "boton-de-reloj-historico") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-965.000000, -422.000200)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "boton-de-reloj-historico",
    transform: "translate(965.000000, 422.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.425293)",
    id: "history"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.92500068,0 C5.95000034,0 3.31500017,1.61500016 1.95499991,4.07999986 L0,2.12500004 L0,7.65000015 L5.52500034,7.65000015 L3.145,5.27000049 C4.25,3.14500045 6.37500051,1.70000036 8.92500068,1.70000036 C12.41,1.70000013 15.3000007,4.59000006 15.3000007,8.075 C15.3000007,11.5600004 12.41,14.4500009 8.92500068,14.4500009 C6.12000068,14.4500009 3.82500017,12.6650005 2.89,10.2000008 L1.10500008,10.2000008 C2.04000017,13.6000006 5.18500068,16.15 8.92500068,16.15 C13.43,16.15 17,12.4950008 17,8.075 C17,3.65500017 13.3450017,0 8.92500068,0 L8.92500068,0 Z M7.6499634,4.25 L7.6499634,8.58499857 L11.6449636,10.964998 L12.3249634,9.85999807 L8.92496343,7.81999874 L8.92496343,4.25 L7.6499634,4.25 L7.6499634,4.25 Z",
    id: "Shape",
    fill: "currentColor"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockRefresh);
export default __webpack_public_path__ + "static/media/clock-refresh.bb19db52ef84028c731e8c899b39170f.svg";
export { ForwardRef as ReactComponent };